import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static values = {
    url: String,
    placeholder: String,
    autoSubmit: Boolean
  }
  static targets = ["select"]

  connect() {
    this.initializeChoices()
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy()
      this.choices = null
    }
  }

  initializeChoices() {
    const element = this.selectTarget

    // Initialize Choices.js
    this.choices = new Choices(element, {
      removeItemButton: true,
      searchEnabled: true,
      searchPlaceholderValue: this.placeholderValue || 'Seleccionar...',
      placeholder: true,
      placeholderValue: this.placeholderValue || 'Seleccionar...',
      noResultsText: 'No se encontraron resultados',
      noChoicesText: 'No hay opciones para elegir',
      itemSelectText: false,
      loadingText: 'Cargando...',
      searchResultLimit: 20,
      shouldSort: false,
      renderChoiceLimit: 20
    })

    if (this.hasUrlValue) {
      this.setupAsyncSearch()
    }

    // Solo agregar el evento de submit automático si está habilitado
    if (this.hasAutoSubmitValue && this.autoSubmitValue) {
      element.addEventListener('change', () => {
        this.submitFormWithCleanURL()
      })
    }
  }

  submitFormWithCleanURL() {
    const form = this.selectTarget.closest('form')
    if (!form) return

    const formData = new FormData(form)
    const params = new URLSearchParams()

    for (let [key, value] of formData.entries()) {
      params.append(key, value)
    }

    let queryString = params.toString().replace(/%5B/g, '[').replace(/%5D/g, ']')
    let url = form.action + (queryString ? ('?' + queryString) : '')

    if (window.Turbo) {
      window.Turbo.visit(url, { action: 'advance' })
    } else {
      window.location.href = url
    }
  }

  setupAsyncSearch() {
    let searchTimeout = null

    this.selectTarget.addEventListener('search', (event) => {
      const query = event.detail.value.trim()

      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }

      if (query.length < 2) {
        return
      }

      searchTimeout = setTimeout(async () => {
        try {
          const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
          const data = await response.json()

          const existingValues = Array.from(this.selectTarget.selectedOptions).map(option => option.value)
          const existingChoiceValues = this.choices._store.choices.map(choice => choice.value)

          const newChoices = data.filter(item =>
            !existingValues.includes(item.value) &&
            !existingChoiceValues.includes(item.value)
          )

          if (newChoices.length > 0) {
            this.choices.setChoices(newChoices, 'value', 'label', false)
          }
        } catch (error) {
          console.error('Error fetching institutions:', error)
        }
      }, 500)
    })
  }
}
